import React from 'react';
import Home from './Home';

const HomeContainer: React.FC = (props) => {
    return <Home />;
};

export default HomeContainer;